import React, {useCallback} from 'react'
import { observer, useLocalObservable } from "mobx-react-lite"
import { useNavigate } from "@reach/router"
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import LoadingButton from '@mui/lab/LoadingButton';
import Link from '@mui/material/Link';
import ErrorIcon from '@mui/icons-material/Error';

import classes from './ForgotPassword.module.scss'
import { requestResetPassword } from '../account/AccountAPI'
import useTitle from '../../hooks/title';


const ForgotPassword = observer(() => {
  const inputClasses = {'root':classes.input, 'notchedOutline': classes.notchedOutline}
  const navigate = useNavigate()
  useTitle('Forgot Password')

  const toLogin = useCallback(() => {
    // navigate(`/login`, {replace: true})
    navigate('/auth/login')
  }, [navigate])

  const toBack = useCallback(() => {
    // navigate(`/login`, {replace: true})
    navigate(-1)
  }, [navigate])

  const form = useLocalObservable(() => ({
    email: '',
    send: false,
    loading: false,
    error: null,
    immediately: false,
    handleEmail(e) {
      this.email = e.target.value
      this.immediately && this.validEmail()
    },
    validEmail() {
      if (this.email.length < 1) {
        this.error = 'Email is required'
        return false
      }
      const pattern = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/g
      if (!(pattern.test(this.email.toString()))) {
        this.error = 'Email is invalid'
        return false
      }
      this.error = null
      return true
    },
    setSend() {
      this.send = true
      this.email = ''
    },
    setLoading(loading) {
      this.loading = loading
    },
    setError(err) {
      this.error = err
    },
    async handleSubmit() {
      try {
        this.immediately = true
        if (!this.validEmail()) {
          return;
        }
        this.setLoading(true)
        await requestResetPassword({email: this.email})
        this.setSend()
      } catch (e) {
        console.error('reset fail', e)
        this.setError('Sorry, we can’t find this email address')
      } finally {
        this.setLoading(false)
      }
    },
    handleKeyup(e) {
      if(e.keyCode === 13) {
        this.handleSubmit()
      }
    }
  }))

  return <div className={classes.center}>
      <h1>Forgot password?</h1>
      {form.send ? <div className={classes.tipsArea}>
        <div className={classes.wrapper}></div>
        <div className={classes.tipsIcon}><ErrorIcon /></div>
        <div className={classes.tipsText}>We’ve sent you an email with a link to reset your password. Remember to check your spam folder.</div>
      </div> : <div className={classes.tips}>
        Please enter your email address in the form below and we'll send you a reset link.
      </div>}
      
      <FormControl className={classes.field}>
        <OutlinedInput classes={inputClasses} 
          name="email"
          size="small" 
          value={form.email}
          placeholder="Email"
          onChange={form.handleEmail} 
          onKeyUp={form.handleKeyup}  />
      </FormControl>
      {form.error ? <div className={classes.error}>{form.error}</div> : null}

      <LoadingButton
        className={classes.submit}
        variant="contained" 
        disableElevation 
        loading={form.loading}
        onClick={form.handleSubmit}
        >Submit</LoadingButton>

      {form.send ? <Link className={classes.cancel} onClick={toLogin} underline="none">Log in</Link> 
        : <Link className={classes.cancel} onClick={toBack} underline="none">Cancel</Link>}
    </div>
})

export default ForgotPassword